import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useElementForkRef } from '@cian/react-utils';
import { Popper } from '../../../internal/components/Popper';
import { PREVENT_OVERFLOW, FLIP } from '../../../internal/components/Popper/modifiers';
/**
 * Компонента для открытия выпадающего контента с привязкой к элементу
 */
export function Popover(props) {
  var open = props.open,
    content = props.content,
    preventOverflow = props.preventOverflow,
    flip = props.flip,
    placement = props.placement;
  var _useElementForkRef = useElementForkRef(props.children),
    _useElementForkRef2 = _slicedToArray(_useElementForkRef, 2),
    refferedChildren = _useElementForkRef2[0],
    childrenRef = _useElementForkRef2[1];
  var modifiers = React.useMemo(function () {
    return [flip && FLIP, preventOverflow && PREVENT_OVERFLOW].filter(Boolean);
  }, [flip, preventOverflow]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, refferedChildren, /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorRef: childrenRef,
    placement: placement,
    modifiers: modifiers
  }, content));
}